import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { loginApi } from "../../api/auth";

export const loginAsync = createAsyncThunk("auth/loginAsync", async (credentials, { rejectWithValue }) => {
  try {
    const response = await loginApi(credentials);
    return response.data;
  } catch (error) {
    console.error({ error });
    return rejectWithValue(error);
  }
});

// Async Thunk for logout
export const logoutUserAsync = createAsyncThunk("auth/logoutUser", async () => {
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("apiKeyGQL");
  sessionStorage.removeItem("user");
  sessionStorage.removeItem("userType");
});

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: sessionStorage.getItem("user") ? JSON.parse(sessionStorage.getItem("user")) : null,
    isAuthenticated: sessionStorage.getItem("token") ? true : false,
    token: sessionStorage.getItem("token") || null,
    userType: sessionStorage.getItem("userType") || null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loginAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        state.isAuthenticated = true
        state.token = action.payload.token;
        state.userType = action.payload.userTypeId === 9 ? 'CareTeam' : 'OrgAdmin';
      })
      .addCase(loginAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(logoutUserAsync.fulfilled, (state) => {
        state.user = null;
        state.isAuthenticated = false
        state.token = null;
      });
  },
});

export default authSlice.reducer;
